import { EventEmitter } from '@angular/core';
import { TemplateService } from '../../../../../services/template.service';
import { CALENDAR_LOCALE } from '../../../../../services/constant';
import { FormBuilder, Validators } from '@angular/forms';
import { combineLatest, concat, from, of, Subject } from 'rxjs';
import { ApiService } from '../../../../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { DocumentIssueFormService } from '../document-issue-form/document-issue-form.service';
var DocumentFormComponent = (function () {
    function DocumentFormComponent(apiService, formBuilder, template, translateService, documentIssueFormService) {
        this.apiService = apiService;
        this.formBuilder = formBuilder;
        this.template = template;
        this.translateService = translateService;
        this.documentIssueFormService = documentIssueFormService;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.documentRequestSelected = new EventEmitter;
        this.abbDataSelected = new EventEmitter();
        this.documentRequestInput$ = new Subject();
        this.searchingDocumentRequest = false;
        this.abbNoChecked = false;
        this.confirmationNoChecked = false;
        this.enabledCustomerRequest = environment.enabledCustomerRequest;
        this.abbNoInput$ = new Subject();
        this.searchingAbbNo = false;
        this.today = new Date();
        this.calendarLocale = CALENDAR_LOCALE.EN;
        this.departments = [];
    }
    DocumentFormComponent.prototype.ngDoCheck = function () {
        this.changeCalendarLocale();
    };
    DocumentFormComponent.prototype.ngOnInit = function () {
        this.changeCalendarLocale();
        this.setDocumentTypes();
        this.createDocumentForm();
        this.loadDocumentRequest();
        this.loadDepartments();
        this.loadAbbData();
        // any time the inner form changes update the parent of any change
        this.createSubscriptions();
        if (this.documentInformation) {
            this.returnDocumentDropdown(this.documentInformation);
        }
    };
    DocumentFormComponent.prototype.returnDocumentDropdown = function (documentInformation) {
        var _this = this;
        this.apiService.getDocumentRequestDropdown({ request_no: documentInformation.request_no }).subscribe(function (res) {
            _this.documentRequests$ = from([res]);
        });
        if (documentInformation.abb_no) {
            this.apiService.getAbbDataDropdown({ abb_no: documentInformation.abb_no }).subscribe(function (res) {
                _this.abbData$ = from([res]);
                _this.onChangeAbbNo(res[0]);
                _this.loadAbbData(res);
            });
        }
    };
    Object.defineProperty(DocumentFormComponent.prototype, "currentLang", {
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.loadDocumentRequest = function () {
        var _this = this;
        this.documentRequests$ = concat(of([]), this.documentRequestInput$.pipe(filter(function (term) { return term != null && term.length >= 2; }), distinctUntilChanged(), debounceTime(300), tap(function () { return _this.searchingDocumentRequest = true; }), switchMap(function (term) {
            return _this.apiService.getDocumentRequestDropdown({ request_no: term }).pipe(catchError(function () { return of([]); }), tap(function () { return _this.searchingDocumentRequest = false; }));
        })));
    };
    DocumentFormComponent.prototype.loadAbbData = function (existedAbbData) {
        var _this = this;
        this.abbData$ = concat(existedAbbData ? of(existedAbbData) : of([]), this.abbNoInput$.pipe(filter(function (term) { return term != null && term.length >= 2; }), distinctUntilChanged(), debounceTime(300), tap(function () { return _this.searchingAbbNo = true; }), switchMap(function (term) {
            return _this.apiService.getAbbDataDropdown({ abb_no: term }).pipe(catchError(function () { return of([]); }), tap(function () { return _this.searchingAbbNo = false; }));
        })));
    };
    DocumentFormComponent.prototype.onChangeAbbNo = function (event) {
        this.abbDataSelected.emit(event);
    };
    DocumentFormComponent.prototype.loadDepartments = function () {
        var _this = this;
        this.apiService.getDepartments().subscribe(function (res) {
            if (res.length > 0) {
                if (_this.translateService.currentLang === 'en') {
                    _this.departments = res.map(function (department) { return ({
                        label: department.name_en,
                        value: department.id,
                    }); });
                }
                else {
                    _this.departments = res.map(function (department) { return ({
                        label: department.name_th,
                        value: department.id,
                    }); });
                }
            }
        }, function (error) {
            console.log(error);
        });
    };
    DocumentFormComponent.prototype.changeDepartment = function (event) {
        this.getRunnningInvoiceNo(event.value);
        this.documentForm.patchValue({
            department: event.value,
        });
        this.loadProducts(event.value);
    };
    DocumentFormComponent.prototype.onChangeDocumentRequest = function (event) {
        if (event && event.abb_no) {
            this.abbNoChecked = true;
            this.abbNo.enable();
        }
        else {
            this.abbNoChecked = false;
            this.abbNo.disable();
        }
        if (event && event.confirmation_no) {
            this.confirmationNoChecked = true;
            this.confirmationNo.enable();
        }
        else {
            this.confirmationNoChecked = false;
            this.confirmationNo.disable();
        }
        this.documentForm.patchValue({
            abbNo: event ? event.abb_no : '',
            confirmationNo: event ? event.confirmation_no : '',
        });
        this.documentRequestSelected.emit(event);
    };
    DocumentFormComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.documentIssueFormService.selectedProducts.next([]);
    };
    DocumentFormComponent.prototype.writeValue = function (value) {
        if (value) {
            this.documentForm.setValue(value);
            this.onChange(value);
            this.onTouched();
        }
    };
    DocumentFormComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DocumentFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // communicate the inner form validation to the parent form
    DocumentFormComponent.prototype.validate = function (_control) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.documentForm.valid ? resolve(null) : resolve({ documentForm: { valid: false } });
        });
    };
    DocumentFormComponent.prototype.createSubscriptions = function () {
        var _this = this;
        // Subscribe to valueChanges and statusChanges
        this.subscription = combineLatest([this.documentForm.valueChanges, this.documentForm.statusChanges]).subscribe(function () {
            _this.onChange(_this.documentForm.getRawValue());
            _this.onTouched();
        });
    };
    DocumentFormComponent.prototype.setDocumentTypes = function () {
        var _this = this;
        this.documentTypes = this.template.getDropdown();
        if (this.isCreditNote || this.isDebitNote) {
            this.documentTypes.shift();
        }
        else {
            this.documentTypes = this.documentTypes.filter(function (element) { return element.value === _this.documentType; });
        }
    };
    DocumentFormComponent.prototype.changeCalendarLocale = function () {
        this.lang = localStorage.getItem('lang');
        this.calendarLocale = this.lang && this.lang === 'th' ? CALENDAR_LOCALE.TH : CALENDAR_LOCALE.EN;
    };
    Object.defineProperty(DocumentFormComponent.prototype, "isCreditNote", {
        get: function () {
            return this.documentType === 'credit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "isDebitNote", {
        get: function () {
            return this.documentType === 'debit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "isDeliveryOrder", {
        get: function () {
            return this.documentType === 'delivery_order_tax_invoice';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "isReceiptTaxInvoice", {
        get: function () {
            return this.documentType === 'receipt_tax_invoice';
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.createDocumentForm = function () {
        var documentType = this.documentTypes.length === 1 ? this.documentTypes[0].value : null;
        var required = (this.isCreditNote || this.isDebitNote) ? Validators.required : null;
        this.documentForm = this.formBuilder.group({
            documentNo: [null, Validators.required],
            documentDate: [this.today, Validators.required],
            abbNo: [],
            confirmationNo: [{ value: null, disabled: true }],
            documentRequest: [],
            orderNo: [{ value: null, disabled: true }],
            runningNo: [{ value: null, disabled: true }],
            purpose: [null, required],
            department: [null, Validators.required],
            referenceDocuments: this.formBuilder.array([
                this.formBuilder.group({
                    documentNo: [null, required],
                    documentType: [documentType, required],
                    documentDate: [null, required]
                })
            ])
        });
    };
    Object.defineProperty(DocumentFormComponent.prototype, "department", {
        get: function () {
            return this.documentForm.get('department');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "documentNo", {
        get: function () {
            return this.documentForm.get('documentNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "documentDate", {
        get: function () {
            return this.documentForm.get('documentDate');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "abbNo", {
        get: function () {
            return this.documentForm.get('abbNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "confirmationNo", {
        get: function () {
            return this.documentForm.get('confirmationNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "orderNo", {
        get: function () {
            return this.documentForm.get('orderNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "runningNo", {
        get: function () {
            return this.documentForm.get('runningNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "purpose", {
        get: function () {
            return this.documentForm.get('purpose');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "referenceDocuments", {
        get: function () {
            return this.documentForm.get('referenceDocuments');
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.getReferenceDocumentNo = function (index) {
        return this.referenceDocuments.controls[index].get('documentNo');
    };
    DocumentFormComponent.prototype.getReferenceDocumentType = function (index) {
        return this.referenceDocuments.controls[index].get('documentType');
    };
    DocumentFormComponent.prototype.getReferenceDocumentDate = function (index) {
        return this.referenceDocuments.controls[index].get('documentDate');
    };
    DocumentFormComponent.prototype.addReferenceDocument = function () {
        this.referenceDocuments.push(this.formBuilder.group({
            documentNo: [null, Validators.required],
            documentType: [null, Validators.required],
            documentDate: [null, Validators.required]
        }));
    };
    DocumentFormComponent.prototype.removeReferenceDocument = function (index) {
        this.referenceDocuments.removeAt(index);
    };
    DocumentFormComponent.prototype.getRunnningInvoiceNo = function (id) {
        var _this = this;
        var params = {
            department_id: id,
        };
        this.apiService.getInvoiceNumber(params).subscribe(function (res) {
            if (res) {
                _this.documentForm.patchValue({
                    documentNo: res
                });
            }
        }, function (error) {
            console.log(error);
        });
    };
    DocumentFormComponent.prototype.loadProducts = function (id) {
        var _this = this;
        var params = {
            department_id: id,
        };
        this.apiService.getProducts(params).subscribe(function (result) {
            if (result.length > 0) {
                _this.documentIssueFormService.selectedProducts.next(result.map(function (product) { return ({
                    product_id: product.product_id,
                    product_name: product.name_th + " (" + product.name_en + ")"
                }); }));
            }
        }, function (error) {
            console.log(error);
        });
    };
    return DocumentFormComponent;
}());
export { DocumentFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-form/document-form.component.ts.pre-build-optimizer.js